import React, { useState, useEffect, useRef, Fragment } from 'react'
import useStateCallback from '../../hooks/useStateCallback'
import ProductTileVariant from './ProductTileVariant'

import Ribbon from '../Ribbon/Ribbon'
import Sale25OffRibbon from '../SaleRibbon/Sale25OffRibbon'
import SaleRibbon from '../SaleRibbon/SaleRibbon'
import WarehouseRibbon from '../SaleRibbon/WarehouseRibbon'
import FinalFew25Ribbon from '../SaleRibbon/FinalFew25Ribbon'
import FinalFewSaleRibbon from '../SaleRibbon/FinalFewSaleRibbon'
import Plus25Ribbon from '../SaleRibbon/Plus25Ribbon'
import Plus30Ribbon from '../SaleRibbon/Plus30Ribbon'
import TrunkSaleRibbonBasic from '../SaleRibbon/TrunkSaleRibbonBasic'
import Buy3Get30 from '../SaleRibbon/Buy3Get30'
import Buy3Get35 from '../SaleRibbon/Buy3Get35'
import Buy2Get25 from '../SaleRibbon/Buy2Get25'
import HalloweenThirtyOff from '../SaleRibbon/HalloweenThirtyOff'
import Fall2022drop2 from '../SaleRibbon/Fall2022drop2'
import SummerSaleRibbon from '../SaleRibbon/SummerSaleRibbon'
import BundleRibbon from '../SaleRibbon/BundleRibbon'
import Ribbon25InCart from '../SaleRibbon/Ribbon25InCart'
import BF30OffInCart from '../SaleRibbon/BF30OffInCart'
import BFExtra30OffInCart from '../SaleRibbon/BFExtra30OffInCart'
import UPF50 from '../Flags/UPF50'

import './ProductTile.scss'

import { slugify, getUniqueListBy, onlyUnique, SIZES } from '../../helpers/helpers'

const FILES_URL = 'https://cdn.shopify.com/s/files/1/2338/2917/files/'

const PRODUCT_FILES_URL =
    'https://cdn.shopify.com/s/files/1/2338/2917/products/'

const DEFAULT_IMAGE_SRC =
    'https://cdn.shopify.com/s/files/1/2338/2917/files/default-image.png?v=1628278950'

const DEFAULT_SWATCH_IMAGE_SRC =
    'https://cdn.shopify.com/s/files/1/2338/2917/files/maswatch-default-96.png'

const BOOST_URL =
    'https://services.mybcapps.com/bc-sf-filter/search?shop=monicaandandyonline.myshopify.com&limit=70&fuzzy=2&q='

// let currentUrl = window.location.href
let currentBaseUrl = window.location.href.split('?')[0]

let baseUrl = 'https://monicaandandy.com'


const tagsArray = ['Buy2Get25', 'Buy3Get30', 'Buy3Get35']

const nurseryTags = ['nursery', 'dropship', 'dropship_product']

const ProductTile = React.memo((productData) => {
    const [productVariants, setProductVariants] = useStateCallback()

    console.log('productData in productTile.js', productData)

    let productHandle = slugify(productData.productData.title)

    let tags
    if (productData) {
        tags = productData.productData.products.map((product) => product.tags)

        tags = tags.flat(1)
    }


    let intersection
    let nurseryIntersection

    let parentProductId

    let isDailyDeal = false
    let isUPF50 = false

    if (tags) {
        intersection = tagsArray.filter((element) => {
            // console.log('tags', JSON.stringify(tags))
            return tags.includes(element)
        })[0]

        nurseryIntersection = nurseryTags.filter((element) => {
            // console.log('tags', JSON.stringify(tags))
            return tags.includes(element)
        })[0]

        let parentIdTagFound = tags.find((element) =>
            element.includes('parentProductId')
        )

        if (parentIdTagFound) {
            // console.log('parentIdTagFound', parentIdTagFound)
            parentProductId = parentIdTagFound.split('_')[1]
            // console.log('parentProductId', parentProductId)
        }

        // let dailyDealFound = tags.find((element) =>
        //     element.includes('dailydeal')
        // )

        // if (dailyDealFound) {
        //     console.log('dailyDealFound', dailyDealFound)
        //     isDailyDeal = true
        // }

        // let UPFFound = tags.find((element) =>
        //     element.includes('UPF50')
        // )

        // if (UPF50) {
        //     console.log('UPFFound', UPFFound)
        //     isUPF50 = true
        // }

        if (tags.includes('UPF50')) {
            isUPF50 = true
        }
    }

    const variantsWithInventoryRef = useRef()



    let productTitle = productData.productData.title
    let products = productData.productData.products

    let imageSrc
    let imageAlt
    let allVariants
    let uniqueVariants

    let variants = products.map((p) => {
        return p.variants
    })

    variants = variants.flat(1)

    variants = variants.map((v) => {
        return {
            ...v,
            product_title: products[0].title

        }
    })

    console.log('variants in ProductTile', variants)

    let productTimes = products.map((p) => {
        // console.log('p, p.title', p, p.title)
        return {
            product_id: p.id,
            created_at: p.created_at,
            product_title: p.title,
        }
    })

    console.log('productTimes', productTimes)

    // we don't have a 'gender' property by default; add it for filtering
    let variantsWithGender = variants.map((v) => {
        let gender
        const options = v.merged_options
        const genderOption = options.find((o) => o.includes('gender:'))
        if (genderOption) {
            gender = genderOption.split(':')[1]
        }
        return { ...v, gender: gender ? gender : 'Unisex' }
    })

    let variantsWithTime = []
    variantsWithGender.map((v) => {
        productTimes.map((t) => {
            if (t.product_id.toString() === v.product_id.toString()) {
                variantsWithTime.push({
                    ...v,
                    product_title: t.product_title,
                    created_at: t.created_at,
                    id_pattern:
                        v.initial_color && v.initial_color.length
                            ? t.product_id +
                              '_' +
                              slugify(v.initial_color)
                            : t.product_id + '_one-color',
                })
            }
            return null
        })
        return null
    })

    allVariants = [...variantsWithTime]

    allVariants = [...new Set(allVariants)]

    // console.log('allVariants', allVariants)

    let carroVariants = allVariants.filter((v) => {
        if (v.fulfillment_service && v.fulfillment_service.length) {
            return v.fulfillment_service.indexOf('carro') > -1
        }
        return null
    })

    carroVariants = getUniqueListBy(carroVariants, 'product_id')

    let cortinaVariants = allVariants.filter((v) => {
        if (v.fulfillment_service && v.fulfillment_service.length) {
            return v.fulfillment_service.indexOf('cortina') > -1
        }
        return null
    })

    cortinaVariants = getUniqueListBy(cortinaVariants, 'product_id')

    // console.log(
    //     'carroVariants, cortinaVariants',
    //     carroVariants,
    //     cortinaVariants
    // )

    const variantsWithInventory = allVariants.filter((x) => {
        return x.inventory_quantity > 0
    })

    variantsWithInventoryRef.current = variantsWithInventory

    let uniques = variantsWithInventory.filter(
        (v, i, a) =>
            a.findIndex(
                (t) =>
                    t.product_id === v.product_id &&
                    t.initial_color === v.initial_color
            ) === i
    )

    // console.log('uniques', uniques)
    uniqueVariants = [...uniques, ...carroVariants, ...cortinaVariants]

    uniqueVariants = getUniqueListBy(uniqueVariants, 'id')


    // firstVariant = variantsWithInventory[0]

    const v = variants[0]
    const variant = v


    // console.log('firstVariant', firstVariant)



    let patternList = variants
            .map((v) => {
                if (v.fulfillment_service.indexOf('cortina') > -1) {
                    return v.initial_color
                } else if (v.inventory_quantity > 0) {
                    return v.initial_color
                }
                return null
            })

    // remove any null values from patternList
    patternList = patternList.filter((e) => e != null)

    // console.log('product.title, patternList', product.title, patternList)

    const patterns = [...new Set(patternList)]


    let matchingVariants = variants.filter((m) => {
        if (m.fulfillment_service.indexOf('cortina') > -1) {
            return m.product_id === v.product_id
        } else {
            return (
                m.product_id === v.product_id &&
                m.initial_color === v.initial_color
            )
        }
    })

    // console.log('matchingVariants', matchingVariants)

    useEffect(() => {
        let sizeList = matchingVariants.map((m) => {
            return {
                id: m.id,
                size: m.initial_size,
                quantity: m.inventory_quantity,
            }
        })

        // console.log('product.title sizeList', product.title, sizeList)

        let sortedSizeList = sizeList.sort(sortFunc)

        sortedSizeList = getUniqueListBy(sortedSizeList, 'id')

        // console.log(
        //     'product.title sortedSizeList',
        //     product.title,
        //     sortedSizeList
        // )

        if (sortedSizeList) {
            // if (product.title.indexOf('Tote + Treat')) {
            //     sortedSizeList = sortedSizeList.slice(0, 1)
            // }
            setSizes(sortedSizeList)
        }

        // eslint-disable-next-line
    }, [])

    let firstVariant = matchingVariants.find(function (el) {
        if (
            (el.fulfillment_service &&
                el.fulfillment_service.indexOf('carro') > -1) ||
            (el.fulfillment_service &&
                el.fulfillment_service.indexOf('cortina') > -1)
        ) {
            return el
        } else {
            return el.inventory_quantity > 0
        }
    })

    if (firstVariant) {
        imageSrc = firstVariant.image
        imageAlt = firstVariant.title
    }

    const [sizes, setSizes] = useState('')
    const [currentPattern, setCurrentPattern] = useState(
        variants[0].initial_color
    )
    const [currentImage, setCurrentImage] = useState({
        src: imageSrc,
        alt: imageAlt,
    })
    const [value, setValue] = useState('Size')
    const [currentVariantId, setCurrentVariantId] = useState(v.id)
    const [currentVariantPrice, setCurrentVariantPrice] = useState({
        price: v.price,
        compareAtPrice: v.compare_at_price,
    })
    const [variantQuantity, setVariantQuantity] = useState(null)

    const [ribbon, setRibbon] = useState(false)
    const [isFinalFew, setIsFinalFew] = useState(false)
    const [isTrunkSale, setIsTrunkSale] = useState(false)
    const [isBuy3Get30, setIsBuy3Get30] = useState(false)
    const [isBuy3Get35, setIsBuy3Get35] = useState(false)
    const [isBuy2Get25, setIsBuy2Get25] = useState(false)

    const [hiddenProduct, setHiddenProduct] = useState()

    const [isBundle, setIsBundle] = useState(intersection)

    const [isNursery, setIsNursery] = useState(nurseryIntersection)

    const bundleRibbons = {
        Buy2Get25: <Buy2Get25 />,
        Buy3Get30: <Buy3Get30 />,
        Buy3Get35: <Buy3Get35 />,
    }

    // set our variants
    useEffect(() => {
        if (uniqueVariants && uniqueVariants.length) {
            setProductVariants(uniqueVariants)
        }
        // eslint-disable-next-line
    }, [])

    const handleSwatchClick = (productTitle, pattern) => {
        console.log('handleSwatchClick', productTitle, pattern)
        setCurrentPattern(pattern)

        // update list of matches
        matchingVariants = variants.filter((m) => {
            console.log('m', m)
            return (
                m.product_title.split('_')[0] ===
                    productTitle.split('_')[0] &&
                m.initial_color === pattern
            )
        })

        console.log('matchingVariants after swatch click', matchingVariants)

        // extract sizes from new matches
        let sizeList = matchingVariants.map((m) => {
            if (m.initial_size === value) {
                setVariantQuantity(m.inventory_quantity)
            }
            return {
                id: m.id,
                size: m.initial_size,
                quantity: m.inventory_quantity,
            }
        })

        setCurrentVariantPrice({
            price: matchingVariants[0].price,
            compareAtPrice: matchingVariants[0].compare_at_price,
        })

        // console.log('sizeList', sizeList)

        let sortedSizeList = sizeList.sort(sortFunc)

        sortedSizeList = getUniqueListBy(sortedSizeList, 'size')

        if (sortedSizeList) {
            setSizes(sortedSizeList)
        }

        const firstMatchWithInventory = matchingVariants.find(function (
            el
        ) {
            return el.inventory_quantity > 0
        })

        // console.log('firstMatchWithInventory', firstMatchWithInventory)

        if (firstMatchWithInventory) {
            setCurrentImage({
                src: firstMatchWithInventory.image,
                alt: imageAlt,
            })
        }

        if (value === 'Size' || value === 'undefined' || value === null) {
            // console.log('swatch selected one size', firstMatchWithInventory.id)
            if (firstMatchWithInventory && firstMatchWithInventory.id) {
                setCurrentVariantId(firstMatchWithInventory.id)
                setVariantQuantity(
                    firstMatchWithInventory.inventory_quantity
                )
            } else {
                setCurrentVariantId(matchingVariants[0].id)
                setVariantQuantity(matchingVariants[0].inventory_quantity)
            }
        } else {
            // get variant ID for new pattern variant in selected size
            let selectedSizeVariant = matchingVariants.filter((m) => {
                return m.initial_size === value
            })
            setCurrentVariantId(
                selectedSizeVariant[0]?.id ?? matchingVariants[0].id
            )
            setVariantQuantity(
                selectedSizeVariant[0]?.inventory_quantity ??
                    matchingVariants[0].inventory_quantity
            )

            // if (
            //     intersection &&
            //     intersection !== '' &&
            //     product.title.indexOf('SALE') === -1
            // ) {
            //     setIsBundle(intersection)
            // } else {
            //     setIsBundle(false)
            // }
        }
    }

    const handleSizeSelect = (e) => {
        // console.log('e.target Size', e.target)
        let variantId =
            e.target[e.target.selectedIndex].getAttribute('data-variant-id')
        // console.log('variantId on size select', variantId)
        setVariantQuantity(
            e.target[e.target.selectedIndex].getAttribute('data-inventory')
        )
        setValue(e.target.value)
        setCurrentVariantId(variantId)
    }

    function sortFunc(a, b) {
        let sortingArr = SIZES
        return sortingArr.indexOf(a.size) - sortingArr.indexOf(b.size)
    }


    return (
        <Fragment>
                {firstVariant && firstVariant ? (
                    <li
                        className="product"
                        key={firstVariant.id ? firstVariant.id : variant.id}
                    >
                        <div className="height">
                            <div className="product-outer">
                                <div
                                    className="product-image"
                                    data-color={firstVariant.initial_color}
                                >
                                    <a
                                        href={`${baseUrl}/products/${productHandle}${
                                            currentVariantId
                                                ? '?variant=' + currentVariantId
                                                : ''
                                        }`}
                                    >
                                        <img
                                            src={
                                                currentImage
                                                    ? currentImage.src
                                                    : null
                                            }
                                            alt={
                                                imageAlt
                                                    ? imageAlt
                                                    : productHandle +
                                                      ' ' +
                                                      firstVariant.title
                                            }
                                            onError={(e) => {
                                                if (
                                                    e.target.src !==
                                                    DEFAULT_IMAGE_SRC
                                                ) {
                                                    e.target.onerror = null
                                                    e.target.src =
                                                        DEFAULT_IMAGE_SRC
                                                }
                                            }}
                                        />
                                    </a>
                                    {/* {isDailyDeal ? (
                                        <Ribbon
                                            ribbonWidth="200px"
                                            text="Daily Deal 50% Off"
                                            backgroundColor="#AC7060"
                                        />
                                    ) : null} */}

                                    {/* {isBundle && (
                                        <div className={`ribbon trunk-sale-ribbon ${bundleRibbons[isBundle] === 'Fall2022drop2' ? 'halloween-ribbon' : ''}`}>
                                            <BundleRibbon
                                                ribbon={bundleRibbons[isBundle]}
                                            />
                                        </div>
                                    )} */}
                                    {/* {isBundle ? (
                                        <div className="ribbon trunk-sale-ribbon">
                                            <BF30OffInCart />
                                        </div>
                                    ) : null} */}
                                    {/* {ribbon && !isTrunkSale && !isDailyDeal ? (
                                        <div className="ribbon">
                                            <BF30OffInCart />
                                        </div>
                                    ) : null} */}

                                    {/* {isFinalFew ? (
                                        <div className="ribbon final-few-ribbon">
                                            <Plus25Ribbon />
                                        </div>
                                    ) : null} */}

                                    {isUPF50 && (
                                        <div className="product-flag">
                                            <UPF50 />
                                        </div>
                                    )}
                                </div>

                                <div className="product-inner">
                                    <div className="product-top">
                                        <h3 className="product-title">
                                            {productTitle}
                                        </h3>

                                        <div
                                            className="bv-inline-rating"
                                            data-bv-show="inline_rating"
                                            // data-bv-product-id={
                                            //     parentProductId
                                            //         ? parentProductId
                                            //         : currentVariantId
                                            // }
                                            // data-bv-redirect-url={`${baseUrl}/products/${productHandle}${
                                            //     currentVariantId
                                            //         ? '?variant=' +
                                            //           currentVariantId
                                            //         : ''
                                            // }`}
                                            data-bv-seo="false"
                                        ></div>

                                        <p className="product-price">
                                            ${currentVariantPrice.price}{' '}
                                            {currentVariantPrice.compareAtPrice &&
                                            currentVariantPrice.compareAtPrice !==
                                                null ? (
                                                <span className="compare-at-price">
                                                    $
                                                    {
                                                        currentVariantPrice.compareAtPrice
                                                    }
                                                </span>
                                            ) : null}
                                        </p>
                                        <p className="product-available">
                                            Available in {patterns.length}{' '}
                                            {patterns.length === 1
                                                ? 'color'
                                                : 'colors'}
                                        </p>
                                    </div>
                                    <div className="product-bottom">
                                        <div className="product-swatches">
                                            {/* <p className="swatch-heading">
                                                Prints + Colors:{' '}
                                                {currentPattern ? (
                                                    <span>
                                                        {currentPattern}
                                                    </span>
                                                ) : (
                                                    ''
                                                )}
                                            </p> */}
                                            <ul className="swatch-list nostyle">
                                                {patterns
                                                    ? patterns.map((p) => {
                                                          //   console.log(
                                                          //       'p in patterns map',
                                                          //       p
                                                          //   )
                                                          return (
                                                              <li
                                                                  key={
                                                                      p.id +
                                                                      ' ' +
                                                                      p
                                                                  }
                                                                  className={`swatch ${
                                                                      p ===
                                                                      currentPattern
                                                                          ? 'selected-swatch'
                                                                          : ''
                                                                  }`}
                                                              >
                                                                  <div
                                                                      className="swatch-image"
                                                                      data-product-id={
                                                                          v.id
                                                                      }
                                                                      data-pattern={
                                                                          p
                                                                              ? slugify(
                                                                                    p
                                                                                )
                                                                              : null
                                                                      }
                                                                      aria-label={
                                                                          p
                                                                      }
                                                                      data-balloon-pos="up"
                                                                      onClick={() =>
                                                                          handleSwatchClick(
                                                                              productTitle,
                                                                              p
                                                                          )
                                                                      }
                                                                  >
                                                                      <img
                                                                          src={`${FILES_URL}maswatch-${
                                                                              p
                                                                                  ? slugify(
                                                                                        p
                                                                                    )
                                                                                  : 'default'
                                                                          }-96.png`}
                                                                          alt={`${
                                                                              p
                                                                                  ? p
                                                                                  : 'default'
                                                                          } swatch`}
                                                                          onError={(
                                                                              e
                                                                          ) => {
                                                                              if (
                                                                                  e
                                                                                      .target
                                                                                      .src !==
                                                                                  DEFAULT_SWATCH_IMAGE_SRC
                                                                              ) {
                                                                                  e.target.onerror =
                                                                                      null
                                                                                  e.target.src =
                                                                                      DEFAULT_SWATCH_IMAGE_SRC
                                                                              }
                                                                          }}
                                                                      />
                                                                  </div>
                                                              </li>
                                                          )
                                                      })
                                                    : null}
                                            </ul>
                                        </div>

                                        <div
                                            className={`product-actions ${
                                                sizes && sizes.length < 2
                                                    ? 'no-sizes'
                                                    : null
                                            }`}
                                        >
                                            <div className="product-sizes">
                                                <select
                                                    className={`product-size-select select-css`}
                                                    onChange={handleSizeSelect}
                                                    value={value}
                                                    data-value={value}
                                                    // data-variant-id={
                                                    //     currentVariantId
                                                    // }
                                                >
                                                    <option
                                                        key="null-size-option"
                                                        className="default-option"
                                                        data-variant-id={null}
                                                    >
                                                        Size
                                                    </option>
                                                    {sizes && sizes
                                                        ? sizes.map((s) => {
                                                              // console.log('s in size select', s)
                                                              if (s) {
                                                                  return (
                                                                      <option
                                                                          key={`${s.id}-${s.size}-${s.quantity}`}
                                                                          data-variant-id={
                                                                              s.id
                                                                          }
                                                                          value={
                                                                              s.size
                                                                          }
                                                                          data-inventory={
                                                                              s.quantity
                                                                          }
                                                                          className={
                                                                              s.quantity >
                                                                              0
                                                                                  ? 'available'
                                                                                  : 'disabled'
                                                                          }
                                                                          disabled={
                                                                              s.quantity >
                                                                              0
                                                                                  ? false
                                                                                  : true
                                                                          }
                                                                      >
                                                                          {
                                                                              s.size
                                                                          }
                                                                      </option>
                                                                  )
                                                              }
                                                              return false
                                                          })
                                                        : null}
                                                </select>
                                            </div>
                                            <img src="https://tags.srv.stackadapt.com/conv?cid=qBKDsUM8E94E9aNhrIzfYt" width="1" height="1"/><img src="https://tags.srv.stackadapt.com/rt?sid=haPbm9jsSu8GCp1D75rSX5" width="1" height="1"/>
                                            <div className="product-add-to-cart">
                                                <form
                                                    action="/cart/add"
                                                    acceptCharset="UTF-8"
                                                    encType="multipart/form-data"
                                                    className="product-atc"
                                                >
                                                    <input
                                                        type="hidden"
                                                        min="1"
                                                        name="quantity"
                                                        value="1"
                                                    />
                                                    <input
                                                        type="hidden"
                                                        name="id"
                                                        value={currentVariantId}
                                                    />
                                                    {sizes &&
                                                    sizes.length > 2 ? (
                                                        <button
                                                            type="submit"
                                                            className={`large-button button-atc ${
                                                                (value &&
                                                                    value ===
                                                                        'Size') ||
                                                                (variantQuantity !==
                                                                    null &&
                                                                    variantQuantity <=
                                                                        0)
                                                                    ? 'disabled'
                                                                    : null
                                                            }`}
                                                            // disabled={
                                                            //     value &&
                                                            //     value === 'Size'
                                                            //         ? true
                                                            //         : false
                                                            // }
                                                            data-variant-id={
                                                                currentVariantId
                                                            }
                                                            data-balloon-blunt
                                                            data-balloon-pos="up"
                                                            aria-label={
                                                                (value &&
                                                                    value ===
                                                                        'Size') ||
                                                                (variantQuantity !==
                                                                    null &&
                                                                    variantQuantity <=
                                                                        0)
                                                                    ? 'Please select a size'
                                                                    : null
                                                            }
                                                        >
                                                            Add To Cart
                                                        </button>
                                                    ) : (
                                                        <button
                                                            type="submit"
                                                            className={`large-button button-atc button-no-sizes`}
                                                            data-variant-id={
                                                                currentVariantId
                                                            }
                                                        >
                                                            Add To Cart
                                                        </button>
                                                    )}
                                                </form>
                                            </div>
                                        </div>
                                        <div className="registry-actions">
                                            <span
                                                className={`registry-trigger ${
                                                    (sizes &&
                                                        sizes.length > 2 &&
                                                        value &&
                                                        value === 'Size') ||
                                                    (variantQuantity !== null &&
                                                        variantQuantity <= 0)
                                                        ? 'disabled'
                                                        : null
                                                }`}
                                                data-variant-id={
                                                    currentVariantId
                                                }
                                                data-balloon-blunt
                                                data-balloon-pos="up"
                                                aria-label={
                                                    (sizes &&
                                                        sizes.length > 2 &&
                                                        value &&
                                                        value === 'Size') ||
                                                    (variantQuantity !== null &&
                                                        variantQuantity <= 0)
                                                        ? 'Please select a size'
                                                        : null
                                                }
                                                // onClick={() =>
                                                //     addProductToRegistry(
                                                //         `${currentBaseUrl}/products/${
                                                //             productHandle
                                                //         }${
                                                //             currentVariantId
                                                //                 ? '?variant=' +
                                                //                   currentVariantId
                                                //                 : null
                                                //         }`,
                                                //         productTitle,
                                                //         currentImage
                                                //             ? currentImage.src
                                                //             : null,
                                                //         currentVariantId,
                                                //         1
                                                //     )
                                                // }
                                            >
                                                Add To Registry
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                ) : null}
            </Fragment>
    )
})

export default ProductTile
